import sdk from '../services/permissions-sdk';
import { startLoading, endLoading } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    roles: [],
    role: {
        name: '',
        policies: [],
        id: '',
        groups: []
    },
    group: [],
    possibleOwners: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_ROLES   = 'setRoles';
export const SET_OWNERS_AND_ROLES = 'setOwnersAndRoles';
export const SET_OWNERS_AND_ROLE = 'setOwnersAndRole';
export const SET_ROLE = 'setRole';
export const SET_GROUP = 'setPersonGroup';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_ROLES: {
            return {
                ...state,
                roles: action.roles
            };
        }
        case SET_OWNERS_AND_ROLES: {
            return {
                ...state,
                possibleOwners: action.possibleOwners,
                roles: action.roles
            };
        }
        case SET_OWNERS_AND_ROLE: {
            return {
                ...state,
                possibleOwners: action.possibleOwners,
                role: action.role
            };
        }
        case SET_ROLE: {
            return {
                ...state,
                role: action.role
            };
        }
        case SET_GROUP: {
            return {
                ...state,
                group: action.group
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function getRoles( ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRoles( )
            .then( ( roles )=>{
                dispatch( setRoles( roles.roles ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getRolesV3( ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRolesV3( )
            .then( ( roles )=>{
                dispatch( setOwnersAndRoles( roles ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getRolesByCompany( companyId ) {
    return ( dispatch ) => {
        dispatch( setRoles( initialState.roles ) );
        dispatch( startLoading() );
        return sdk.getRolesByCompany( companyId )
            .then( ( roles )=>{
                dispatch( setRoles( roles.roles ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getRolesByCompanyV3( companyId ) {
    return ( dispatch ) => {
        dispatch( setRoles( initialState.roles ) );
        dispatch( startLoading() );
        return sdk.getRolesByCompanyV3( companyId )
            .then( ( roles )=>{
                dispatch( setOwnersAndRoles( roles ) );
                dispatch( endLoading() );
            }
            ).catch( res  => {
                dispatch( setOwnersAndRoles( {
                    roles: [],
                    possibleOwners: []
                } ) );
                dispatch( endLoading() );

            } );
    };
}
export function getRoleByCompany( roleId, companyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRoleByCompany( roleId, companyId )
            .then( ( role )=>{
                dispatch( setRole( role.roles ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getRoleByCompanyV3( roleId, companyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRoleByCompanyV3( roleId, companyId )
            .then( ( role )=>{
                dispatch( setOwnersAndRole( role ) );
                dispatch( endLoading() );
            }
        ).catch( res  => {
            dispatch( setOwnersAndRole( {
                roles: [],
                possibleOwners: []
            } ) );
            dispatch( endLoading() );

        } );
    };
}
export function getRole( roleId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRole( roleId )
            .then( ( role )=>{
                dispatch( setRole( role.role ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getRoleV3( roleId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.getRoleV3( roleId )
            .then( ( role )=>{
                dispatch( setRole( role.role ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function deleteRole( roleId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.deleteRole( roleId )
            .then( ( role )=>{
                dispatch( getRoles() );
            }
        );
    };
}
export function deleteRoleV3( roleId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.deleteRoleV3( roleId )
            .then( ( role )=>{
                // dispatch( getRolesV3() );
            }
        );
    };
}
export function saveRole( role ) {
    return ( dispatch ) => {
        return sdk.saveRole( role )
            .then( ( role )=>{
                dispatch( getRoles() );
            }
        );
    };
}
export function saveRoleV3( role ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.saveRole( role );
    };

}
export function addGroupToRole( group, roleId, companyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.addGroupToRoleByCompany( group, roleId, companyId )
            .then( ( role )=>{
                dispatch( setRole( role.role ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function addGroupToRoleV3( group, roleId, companyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return sdk.addGroupToRoleByCompanyV3( group, roleId, companyId )
            .then( ( role )=>{
                dispatch( setRole( role.role ) );
                dispatch( endLoading() );
            }
        );
    };
}
export function getGroupShare( idsGroup ) {
    const userArr = [];
    let result;
    return ( dispatch ) => {

        idsGroup.map( user  => {
        dispatch( startLoading() );
                  sdk.getGroup( user ).then( ( group ) => {
                        result = group.persons.map( ( name ) => { return (  name.givenName + ' ' + name.surname );  } );
                        userArr.push( ...result );
                        dispatch( setPersonGroup( userArr ) );
                        dispatch( endLoading() );
                    } );
                } );
    };
}
export function shareRole( role ) {
    return () => {
        return sdk.shareRole( role );
    };
}
export function shareRoleV3( role, companyId ) {
    return () => {
        return sdk.shareRoleV3( role, companyId );
    };
}
export function setRoles( roles ) {
    return {
        type: SET_ROLES,
        roles
    };
}
export function setOwnersAndRoles( res ) {
    return {
        type: SET_OWNERS_AND_ROLES,
        possibleOwners: res.possibleOwners,
        roles: res.roles
    };
}
export function setOwnersAndRole( res ) {
    return {
        type: SET_OWNERS_AND_ROLE,
        possibleOwners: res.possibleOwners,
        role: res.role
    };
}
export function setRole( role ) {
    return {
        type: SET_ROLE,
        role
    };
}
export function setPersonGroup( group ) {

    return {
        type: SET_GROUP,
        group: [ ...group ]
    };
}
